import { forwardRef } from "react";

import { TitleProps } from "./types";
import { TitleBase } from "./styles";

const getTitleTag = ($fs?: TitleProps["$fs"]): TitleProps["component"] => {
  switch ($fs) {
    case "h40":
      return "h1";
    case "h32":
      return "h2";
    case "h24":
      return "h3";
    default:
      return "h4";
  }
};

/**
 * Title component with dynamic heading level based on font size.
 * @param {string} [props.$fs="h32"] - Font size that determines default heading level;
 * - "h40" -> h1
 * - "h32" -> h2 (default)
 * - "h24" -> h3
 * - others -> h4
 */

const Title = forwardRef<HTMLHeadingElement, TitleProps>(
  ({ component = "h2", $fs = "h32", $fw = "bold", $lh = "lh130", $p, $m, ...rest }, ref) => {
    const _component = component || getTitleTag($fs);

    return (
      <TitleBase
        ref={ref}
        as={_component}
        $fs={$fs}
        $fw={$fw}
        $lh={$lh}
        $p={$p}
        $m={$m}
        {...rest}
      />
    );
  },
);

export default Title;
